import Box from "@mui/material/Box";
import * as React from "react";

import LiveCodingSettingDialog, {
  LiveCodingSettingDialogProps,
} from "../../ms-components/Livecoding/LiveCodingSettingDialog/LiveCodingSettingDialog";

type Status = "PREVIEW" | "IN_CALL";

export type LiveCodingPreJoinScreenProps = {
  previewDialog: Omit<LiveCodingSettingDialogProps, "mode">;
  status: Status;
  VideoChat: React.ReactNode;
};

const LiveCodingPreJoinScreen: React.FC<LiveCodingPreJoinScreenProps> = props => {
  const previewDialog: LiveCodingSettingDialogProps = {
    ...props.previewDialog,
    open: props.previewDialog.open,
    onClose: () => {
      props.previewDialog.onClose?.();
    },
    noButton: {
      onClick: event => {
        props.previewDialog.noButton?.onClick?.(event);
      },
    },
    mode: "PREVIEW",
  };

  return (
    <Box>
      <LiveCodingSettingDialog {...previewDialog} />
      {props.status === "IN_CALL" && props.VideoChat}
    </Box>
  );
};

LiveCodingPreJoinScreen.displayName = "LiveCodingPreJoinScreen";

export default LiveCodingPreJoinScreen;
